module.exports = __webpack_public_path__ + "img/box.713f50cf.svg";